import { useEffect, useState } from 'react';
import { extInfo, extDownload, getCode } from '../api/lionjob';

// Nút tải extension 🦁 + báo đã cài hay chưa. Đặt cạnh dãy tab Lionjob nên tab nào cũng thấy.
// Vì sao cần: trước đây muốn cài phải mò tới thư mục trên máy tôi — người khác không có.
export default function LionjobExtBadge() {
  const [info, setInfo] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [howto, setHowto] = useState(false);

  // Extension đã cài thì bridge.js tự chào; hỏi thêm một tiếng phòng khi nó chào trước lúc ta nghe.
  useEffect(() => {
    const onMsg = (ev) => {
      if (ev.source === window && ev.data?.source === 'lionjob-ext' && ev.data.type === 'ready') setInstalled(true);
    };
    window.addEventListener('message', onMsg);
    window.postMessage({ source: 'lionjob-page', type: 'ping' }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);

  useEffect(() => { if (getCode()) extInfo().then(setInfo).catch(() => {}); }, []);

  async function dl() {
    setBusy(true); setMsg('');
    try {
      await extDownload();
      setMsg('Đã tải. Giải nén rồi làm theo 4 bước bên dưới.');
      setHowto(true);
    } catch (e) {
      setMsg('Lỗi: ' + (e.response?.data?.message || e.message));
    } finally { setBusy(false); }
  }

  const kb = info ? (info.bytes / 1024).toFixed(0) + ' KB' : '';

  return (
    <div className="lx-wrap"><style>{CSS}</style>
      <span className={'lx-dot ' + (installed ? 'on' : 'off')}
        title={installed ? 'Trang này đã nhận ra extension' : 'Chưa nhận ra extension — cài rồi nhớ F5 lại trang'} />
      <span className="lx-lab">{installed ? 'Extension đã cài' : 'Chưa có extension'}</span>
      <button className="lx-btn" onClick={dl} disabled={busy} title={info ? `bản ${info.version} · ${info.files} file · ${kb}` : 'Tải extension 🦁'}>
        {busy ? '⏳ Đang đóng gói…' : '⤓ Tải extension'}
        {info && <span className="lx-ver">v{info.version}</span>}
      </button>
      <button className="lx-link" onClick={() => setHowto((v) => !v)}>{howto ? 'Ẩn' : 'Cài kiểu gì?'}</button>
      {msg && <span className="lx-msg">{msg}</span>}

      {howto && (
        <div className="lx-howto">
          <b>Cài vào Chrome</b>
          <ol>
            <li>Giải nén file vừa tải ra một thư mục <b>để yên đấy</b> — xoá là extension chết.</li>
            <li>Mở <code>chrome://extensions</code> → bật <b>Developer mode</b> (góc phải trên).</li>
            <li>Bấm <b>Load unpacked</b> → chọn đúng thư mục vừa giải nén (thư mục có <code>manifest.json</code>).</li>
            <li>Bấm icon 🦁 → <b>⚙︎ Cấu hình</b> → điền <i>Ingest endpoint</i> và <i>Mã code Lionjob</i> → Lưu.</li>
          </ol>
          <div className="lx-note">
            Cập nhật bản mới: tải lại, giải nén <b>đè lên thư mục cũ</b>, rồi vào <code>chrome://extensions</code>
            bấm <b>⟳ Reload</b> và F5 lại trang này.
          </div>
        </div>
      )}
    </div>
  );
}

const CSS = `
.lx-wrap{display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:14px}
.lx-dot{width:8px;height:8px;border-radius:50%;flex:none}
.lx-dot.on{background:var(--ok);box-shadow:0 0 0 3px color-mix(in srgb,var(--ok) 22%,transparent)}
.lx-dot.off{background:var(--muted);opacity:.5}
.lx-lab{font-size:12px;color:var(--muted)}
.lx-btn{background:var(--panel);color:var(--text);border:1px solid var(--border);padding:5px 11px;border-radius:9px;
  cursor:pointer;font-size:12px;font-weight:600;display:inline-flex;align-items:center;gap:6px}
.lx-btn:hover:not(:disabled){border-color:var(--accent)}
.lx-btn:disabled{opacity:.55;cursor:not-allowed}
.lx-ver{font-size:10.5px;opacity:.6;font-weight:500}
.lx-link{background:none;border:0;color:var(--muted);font-size:12px;cursor:pointer;text-decoration:underline;padding:0}
.lx-link:hover{color:var(--accent)}
.lx-msg{font-size:12px;color:var(--muted)}
.lx-howto{flex-basis:100%;border:1px solid var(--border);border-radius:12px;padding:12px 15px;background:var(--panel);font-size:12.5px;line-height:1.6}
.lx-howto b{font-size:13px}
.lx-howto ol{margin:7px 0 0;padding-left:20px}
.lx-howto li{margin-bottom:4px}
.lx-howto code{background:var(--input);padding:1px 5px;border-radius:4px;font-family:var(--font-mono);font-size:11.5px}
.lx-note{margin-top:9px;padding-top:9px;border-top:1px solid var(--border);color:var(--muted)}
`;
